module.exports = __webpack_public_path__ + "static/media/x-23-win.ec185412.png";